import { ReactNode } from 'react'

interface ExerciseFrameProps {
  children: ReactNode
}

export default function ExerciseFrame({ children }: ExerciseFrameProps) {
  return (
    <div className="border-2 border-border rounded-2xl bg-card p-4 sm:p-6">
      {children}
    </div>
  )
}
